<template>
  <!-- template for the modal component -->
    <transition name="modal">
      <div class="absolute w-full h-full bg-opacity-70 bg-black
      table top-0 left-0 py-12">
        <div class="table-cell  xs:px-5 xl:pl-96 xl:pr-96 xl:text-center lg:text-center md:text-center">
          <div class="bg-white mt-auto px-30 py-5 rounded-lg transition-all ease-in-out">
            <div class="modal-header">
              <slot name="header">
                default header
              </slot>
            </div>
            <div class="px-8">
              <slot name="body">
                default body
              </slot>
            </div>

            <div class="modal-footer">
              <slot name="footer">
                default footer
                <button class="modal-default-button" @click="$emit('close')">
                  OK
                </button>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </transition>
</template>

<script>
export default {
  data: ()=>({}),
  methods:{},
  mounted() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }
}
</script>

<style scoped>
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>